// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"684":"8a76867acbdabd44","4804":"c2e02cbcae6293ac","7748":"6cb8f89e00651040"}[chunkId] + ".css";
};